module.exports = __webpack_public_path__ + "static/img/transforma-tu-aventura-2.2f005ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/transforma-tu-aventura-2.jpg
// module id = 4EN7
// module chunks = 1